import { addMonths, endOfDay, isSameMonth, startOfMonth } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useShouldHaveRestOfMonth } from 'shared/hooks/use-should-have-rest-of-month';
import { useUser } from 'shared/hooks/use-user';

export const useUpcomingDeadlineDeadlineTasks = () => {
  const today = useToday();
  const user = useUser();

  const { shouldHaveRestOfMonth, restOfMonthStartDate } =
    useShouldHaveRestOfMonth();
  const startMonth =
    shouldHaveRestOfMonth && !isSameMonth(restOfMonthStartDate, today) ? 1 : 0;
  const upcomingTillDate = startOfMonth(addMonths(today, startMonth + 11));

  const { data: tasks } = useTasksQuery(user?.uid, {
    deadlineDeadlineEndDate: endOfDay(upcomingTillDate),
    unFrozenOnly: true,
    uncompletedOnly: true,
  });

  return useMemo(
    () => tasks?.filter(({ archivedAt }) => !archivedAt) ?? [],
    [tasks],
  );
};
